import { createResource } from '../utils/resource'

const vehicleManufacturerStore = createResource('vehicleManufacturer', {})

export default vehicleManufacturerStore
